import React, { lazy, Suspense } from "react";
import Loading from "components/Loading";
import { setTitle } from "utilities/helper/setTitle";

const Guest = lazy(() => import("modules/Auth/Middleware/Guest"));
const LoginContent = lazy(() => import("modules/Auth"));

const LoginPage: React.FC = () => {
  setTitle("Login");
  return (
    <Suspense fallback={<Loading />}>
      <Guest>
        <LoginContent />
      </Guest>
    </Suspense>
  );
};

export default LoginPage;
